import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GuardRegistryService {
    provideB2eAzureCoreGuard = false;
    provideAzureAuthGuard = false;
    provideAzureCoreGuard = false;
    provideOnPremCoreGuard = false;
    provideAuthOidcClientGuard = false;

    checkB2eAzureCoreGuard(): void {
        if (this.provideB2eAzureCoreGuard) {
            throw new Error('B2EAzureCore provided twice');
        }
        this.provideB2eAzureCoreGuard = true;
    }
    checkAzureAuthGuard(): void {
        if (this.provideAzureAuthGuard) {
            throw new Error('AzureAuth provided twice');
        }
        this.provideAzureAuthGuard = true;
    }
    checkAzureCoreGuard(): void {
        if (this.provideAzureCoreGuard) {
            throw new Error('AzureCore provided twice');
        }
        this.provideAzureCoreGuard = true;
    }
    checkOnPremCoreGuard(): void {
        if (this.provideOnPremCoreGuard) {
            throw new Error(
                'OnPremCore provided twice. Hint: configureDefaultInterceptors() should only be called once.'
            );
        }
        this.provideOnPremCoreGuard = true;
    }
    checkAuthOidcClientGuard(): void {
        if (this.provideAuthOidcClientGuard) {
            throw new Error('provideAuthOidcClient provided twice');
        }
        this.provideAuthOidcClientGuard = true;
    }
}
